module.exports = __webpack_public_path__ + "img/banner_Digital.fff5e0a7.png";